var baseApiUrl = "https://api.investing.com/api/financialdata"

export default {

    async loadKlineFromInvesting(symbol, tf) {
        var baseUrl = baseApiUrl + "/" + symbol + "/historical/chart"
        return await fetch(baseUrl + "?period=MAX&interval=" + tf + "&pointscount=120")
    },
    createWs() {
      let key = Math.random().toString(36).substring(8);
      let id = Math.floor(100 + Math.random() * 900);
      this.int_connection = new WebSocket("wss://streaming.forexpros.com/echo/" + id + "/" + key + "/websocket")
    },
    connectWs(onmessage) {
      var self = this
      this.int_connection.onmessage = onmessage;

      this.int_connection.onopen = (event) => {
          var message = "{ \"_event\": \"heartbeat\", \"data\": \"h\"}"
          self.sendWs(message)
      }

      this.int_connection.onclose = (event) => {
          self.createWs();
          self.connectWs(onmessage)
      }
    },
    sendWs(message) {
        var self = this
        this.last_message = message.replace("SUBSCRIBE", "UNSUBSCRIBE")
        var attemptSend = function() {
            if (self.int_connection && self.int_connection.readyState === WebSocket.OPEN) {
                self.int_connection.send(message);
            } else if (self.int_connection && self.int_connection.readyState === WebSocket.CONNECTING) {
                // Queue the message to send once the connection opens
                var origOnOpen = self.int_connection.onopen;
                self.int_connection.onopen = function(event) {
                    if (origOnOpen) origOnOpen(event);
                    self.int_connection.send(message);
                }
            }
        }
        setTimeout(attemptSend, 1000)
    },
    terminateWs() {
        var self = this
        if (this.last_message) {
            setTimeout(() => {
                if (self.int_connection && self.int_connection.readyState === WebSocket.OPEN) {
                    self.int_connection.send(self.last_message)
                }
            }, 1000)
        }
        if (this.int_connection)
            this.int_connection.close()
    },
    destroyWs() {
        if (this.int_connection) {
            this.int_connection.onclose = null;
            this.int_connection.close();
        }
        this.int_connection = null
    }
}
